import React from 'react'
import { useTranslation } from "react-i18next";
import DashboardTable from './dashboard-table';
import "./dashboard.scss"

const BBALMDashboard = () => {
    const { t } = useTranslation();

  return (
    <div className='bb-alm-dashboard-wrapper' >
        <div className='targets' >
                <div className='targets__item' >
                    <div className='targets__item-box red' ></div>
                    <div className='targets__item-title' >{t("BBALMDashboard.targetNotMet")}</div>
                    <div className='targets__item-desc' >{t("BBALMDashboard.breachedLimit")}</div>
                </div>

                <div className='targets__item' >
                    <div className='targets__item-box yellow' ></div>
                    <div className='targets__item-title' >{t("BBALMDashboard.atTarget")}</div>
                    <div className='targets__item-desc' >{t("BBALMDashboard.atTargetPercent")}</div>
                </div>

                <div className='targets__item' >
                    <div className='targets__item-box light-green' ></div>
                    <div className='targets__item-title' >{t("BBALMDashboard.aboveTarget")}</div>
                    <div className='targets__item-desc' >{t("BBALMDashboard.aboveTargetPercent")}</div>
                </div>

                <div className='targets__item' >
                    <div className='targets__item-box green' ></div>
                    <div className='targets__item-title' >{t("BBALMDashboard.targetComfortably")}</div>
                    <div className='targets__item-desc' >{t("BBALMDashboard.targetComfortablyPercent")}</div>
                </div>
        </div>
        <DashboardTable />
    </div>
  )
}

export default BBALMDashboard